/* eslint-disable @direct-frontend/modules/prefer-persistent-slices -- Простая обертка для sessionStorage */

import { isFunction } from '@direct-frontend/stdlib';

/**
 * Ключи для sessionStorage
 */
export type SessionStorageKey = (typeof SessionStorageKey)[keyof typeof SessionStorageKey];
/**
 * Ключи для sessionStorage
 */
export const SessionStorageKey = {
    /** Флаг ожидания регистрации в ПЛ после авторизации */
    LOYALTY_AUTH_PENDING: 'loyalty_auth_pending',
} as const;

/**
 * Обертка для sessionStorage
 * На некоторых мобильных девайсах sessionStorage недоступен и недоступен в SSR
 */
export const sessionStorageHelper = {
    getItem(key: SessionStorageKey): string | null {
        if (isFunction(sessionStorage?.getItem)) {
            return sessionStorage.getItem(key);
        }

        return null;
    },
    setItem(key: SessionStorageKey, value: string): void {
        if (isFunction(sessionStorage?.setItem)) {
            sessionStorage.setItem(key, value);
        }
    },
    removeItem(key: SessionStorageKey): void {
        if (isFunction(sessionStorage?.removeItem)) {
            sessionStorage.removeItem(key);
        }
    },
};
